<div class="amount-display-container">
  @for (section of outstandingByAgeDisplaySections(); track section.title) {
    <div class="amount-display d-flex flex-column justify-content-between p-4 w-100 text-center">
      @if (section.isTimeRange) {
        <p class="mb-1 color-gray-300 fw--600">{{ section.title }}</p>
        <p class="mb-1 color-gray-400 fw--400">Past Due</p>
      } @else {
        <div></div>
        <p class="mb-1 color-gray-300 fw--600">{{ section.title }}</p>
      }

      <p class="fw--600 align-middle" [ngClass]="section.amount === undefined ? 'color-gray-600' : section.amountColor">
        {{ section.amount | nullReplace }}
      </p>
    </div>
  }
</div>

@if (shouldShowLateFeeMessage()) {
  <div id="late-fee-message" class="w-100 mt-3 text-center">
    <p class="mb-0 small-300 color-gray-300">
      Values shown above do not reflect {{ lateFeeDisplayName() }} or Credits. If they exist, they will be shown in the Statement's summary
      below.
    </p>
  </div>
}
